import Typography from '@mui/material/Typography';
import { WhatsNewItem } from 'ff/debrief/models';
import React from 'react';

interface Props {
    item: WhatsNewItem;
}

export const WhatsNewContent: React.FC<Props> = ({ item }) => (
    <>
        <Typography variant="h6" fontWeight="bold" gutterBottom>
            {item.title}
        </Typography>
        <Typography>{item.description}</Typography>
    </>
);
